// Lib
import { bundleIcon, wrapIcon as wrapSvgAsFluentIcon } from "@fluentui/react-icons";
import * as React from "react";
// Animated SVG components
export { ANIMATED_STAR_DURATION_MS, AnimatedStar } from "./svgs/AnimatedStar";
// Fluent system icons
import { AddCircleRegular, AddRegular, AlertUrgentFilled, AlertUrgentRegular, ApprovalsAppFilled as ApprovalsAppFilledFluentIcon, AppsListRegular, AppsRegular, ArchiveRegular, ArrowCircleRightFilled, ArrowClockwiseFilled as ArrowClockwiseFilledFluentIcon, ArrowClockwiseRegular, ArrowCollapseAllFilled as ArrowCollapseAllFilledFluentIcon, ArrowCollapseAllRegular, ArrowCounterclockwiseFilled as ArrowCounterclockwiseFilledFluentIcon, ArrowCounterclockwiseRegular, ArrowDownRegular, ArrowExpandFilled as ArrowExpandFilledFluentIcon, ArrowExpandRegular, ArrowExportLtrFilled as ArrowExportLtrFilledFluentIcon, ArrowExportLtrRegular, ArrowExportRtlFilled as ArrowExportRtlFilledFluentIcon, ArrowExportRtlRegular, ArrowLeftRegular, ArrowMaximizeRegular, ArrowRepeatAllRegular, ArrowResetRegular, ArrowRightFilled, ArrowRightRegular, ArrowSortDownLinesFilled as ArrowSortDownLinesFilledFluentIcon, ArrowSortDownLinesRegular, ArrowSortRegular, ArrowSortUpLinesFilled as ArrowSortUpLinesFilledFluentIcon, ArrowSortUpLinesRegular, ArrowTurnDownLeftFilled as ArrowTurnDownLeftFilledFluentIcon, ArrowTurnDownLeftRegular, ArrowTurnDownRightFilled as ArrowTurnDownRightFilledFluentIcon, ArrowTurnDownRightRegular, ArrowUndoRegular, ArrowUploadRegular, ArrowUpRegular, AttachRegular, BoardFilled, BoardRegular, BoardSplitFilled as BoardSplitFilledFluentIcon, BoardSplitRegular, BookFilled, BotAddRegular, CalendarAddRegular, CalendarClockFilled as CalendarClockFilledFluentIcon, CalendarClockRegular, CalendarDateRegular, CalendarDayFilled as CalendarDayFilledFluentIcon, CalendarDayRegular, CalendarEmptyFilled as CalendarEmptyFilledFluentIcon, CalendarEmptyRegular, CalendarFilled as CalendarFilledFluentIcon, CalendarPersonRegular, CalendarRegular as CalendarRegularFluentIcon, CalendarTodayFilled as CalendarTodayFilledFluentIcon, CalendarTodayRegular, CalendarWorkWeekFilled as CalendarWorkWeekFilledFluentIcon, CalendarWorkWeekRegular, ChartMultipleFilled, ChartMultipleRegular, ChatFilled as ChatFilledFluentIcon, ChatRegular, Checkmark16Filled, CheckmarkCircleFilled, CheckmarkCircleRegular, CheckmarkFilled as CheckmarkFilledFluentIcon, CheckmarkRegular, ChevronDownRegular, ChevronLeftFilled as ChevronLeftFilledFluentIcon, ChevronLeftRegular, ChevronRightFilled as ChevronRightFilledFluentIcon, ChevronRightRegular, ChevronUpRegular, CircleFilled, CircleHalfFillFilled as CircleHalfFillFilledFluentIcon, CircleHalfFillRegular, CircleHintHalfVerticalRegular, CircleHintRegular, CircleRegular, CircleSmallFilled, CircleSmallRegular, ClipboardLinkFilled as ClipboardLinkFilledFluentIcon, ClipboardLinkRegular, ClipboardNoteRegular, ClipboardPasteFilled as ClipboardPasteFilledFluentIcon, ClipboardPasteRegular, ClockRegular, ColorFilled, ColorFillFilled, ColorFillRegular, ColorRegular, ColumnArrowRightFilled as ColumnArrowRightFilledFluentIcon, ColumnArrowRightRegular, ColumnTripleEditFilled, ColumnTripleEditRegular, CommentMultipleRegular, CopyAddFilled as CopyAddFilledFluentIcon, CopyAddRegular, CopyFilled as CopyFilledFluentIcon, CopyRegular, CopySelectFilled as CopySelectFilledFluentIcon, CopySelectRegular, CutFilled as CutFilledFluentIcon, CutRegular, DataBarHorizontalRegular, DeleteFilled as DeleteFilledFluentIcon, DeleteRegular, DismissCircleFilled as DismissCircleFilledFluentIcon, DismissCircleRegular, DismissFilled as DismissFilledFluentIcon, DismissRegular, DividerTallRegular, DocumentBulletListFilled as DocumentBulletListFilledFluentIcon, DocumentBulletListRegular, DocumentPdfRegular, DocumentRegular, DocumentTextExtractFilled as DocumentTextExtractFilledFluentIcon, DocumentTextExtractRegular, EditFilled as EditFilledFluentIcon, EditPersonRegular, EditRegular, EmojiAdd20Filled, EmojiAdd20Regular, ErrorCircleFilled, ErrorCircleRegular, EyeOffFilled as EyeOffFilledFluentIcon, EyeOffRegular, EyeRegular, FilterFilled as FilterFilledFluentIcon, FilterRegular, FlagFilled, FlagRegular, FolderFilled, FolderOpenRegular, FolderPeopleRegular, FolderRegular, GanttChartFilled, GanttChartRegular, GlobeRegular, GridFilled, GridRegular, GroupListFilled as GroupListFluentIconFilled, GroupListRegular, HomeCheckmarkFilled, HomeCheckmarkRegular, HomeRegular, ImageRegular, ImportantFilled, ImportantRegular, InfoFilled as InfoFilledFluentIcon, InfoRegular, Insert20Regular, Keyboard123Filled as Keyboard123FilledFluentIcon, Keyboard123Regular, LinkDismissRegular, LinkFilled as LinkFilledFluentIcon, LinkMultipleFilled as LinkMultipleFilledFluentIcon, LinkMultipleRegular, LinkRegular, ListRegular, LockClosedFilled, LockClosedRegular, LockShieldRegular, MoreHorizontalFilled, MoreHorizontalRegular, MoreVerticalRegular, NavigationRegular, OpenFilled as OpenFilledFluentIcon, OpenRegular, OptionsRegular, PaintBucketFilled, PaintBucketRegular, PanelLeftContractFilled as PanelLeftContractFilledFluentIcon, PanelLeftContractRegular, PanelLeftExpandFilled as PanelLeftExpandFilledFluentIcon, PanelLeftExpandRegular, PanelRightContractRegular, PanelRightExpandRegular, PauseCircleRegular, PauseRegular, PenSync20Filled, PenSync20Regular, PeopleCommunityRegular, PeopleFilled as PeopleFilledFluentIcon, PeopleRegular, PeopleTeamAddRegular, PersonAddRegular, PersonArrowLeftFilled as PersonArrowLeftFilledFluentIcon, PersonArrowLeftRegular, PersonFeedbackFilled as PersonFeedbackFilledFluentIcon, PersonFeedbackRegular, PersonFilled as PersonFilledFluentIcon, PersonRegular, PersonSubtractRegular, PhoneRegular, PinFilled as PinFilledFluentIcon, PinOffFilled as PinOffFilledFluentIcon, PinOffRegular, PinRegular, PlayRegular, PlugConnectedAddFilled, PlugConnectedAddRegular, PlugConnectedRegular, PlugDisconnectedFilled as PlugDisconnectedFilledFluentIcon, PlugDisconnectedRegular, PremiumFilled as PremiumFilledFluentIcon, PremiumRegular, ProhibitedFilled as ProhibitedFilledFluentIcon, ProhibitedRegular, QuestionCircleFilled, QuestionCircleRegular, QuestionRegular, RecordStopRegular, RectanglePortraitRegular, ReOrderDotsVerticalFilled as ReOrderDotsVerticalFilledFluentIcon, ReOrderDotsVerticalRegular, ReOrderRegular, RocketFilled, RocketRegular, SaveFilled as SaveFilledFluentIcon, SaveRegular, SearchFilled as SearchFilledFluentIcon, SearchRegular, SendFilled as SendFilledFluentIcon, SendRegular, SettingsRegular, ShareFilled as ShareFilledFluentIcon, ShareRegular, ShieldErrorRegular, ShieldFilled as ShieldFilledFluentIcon, ShieldLockFilled as ShieldLockFilledFluentIcon, ShieldLockRegular, ShieldQuestionRegular, ShieldRegular, SparkleFilled as SparkleFilledFluentIcon, SparkleRegular as SparkleRegularFluentIcon, SquareDismissRegular, StarFilled, StarRegular, Status20Filled, Status20Regular, StopRegular, SubtractCircleFilled, SubtractRegular, SubtractSquareFilled as SubtractSquareFilledFluentIcon, SubtractSquareRegular, TableFilled as TableFilledFluentIcon, TableRegular, TagEditFilled as TagEditFilledFluentIcon, TagEditRegular, TagFilled as TagFilledFluentIcon, TagRegular, TargetArrowFilled as TargetArrowFilledFluentIcon, TargetArrowRegular, TaskListAddFilled as TaskListAddFilledFluentIcon, TaskListAddRegular, TaskListLtrFilled, TaskListLtrRegular, TaskListSquareLtrRegular, TextEditStyleFilled as TextEditStyleFilledFluentIcon, TextEditStyleRegular, TextFieldRegular, TextIndentDecreaseLtrFilled as TextIndentDecreaseLtrFilledFluentIcon, TextIndentDecreaseLtrRegular, TextPercentFilled as TextPercentFilledFluentIcon, TextPercentRegular, TextSortAscendingRegular, TextTFilled as TextTFilledFluentIcon, TextTRegular, TimelineRegular, TrophyFilled, TrophyRegular, WarningFilled as WarningFilledFluentIcon, WarningRegular, WeatherSunnyFilled, WeatherSunnyRegular } from "@fluentui/react-icons";
// Brand Icons
import { CopilotRegular, ExcelColor, ExcelFilled, ExcelRegular, LoopColor, LoopRegular, OnenoteRegular, OutlookRegular, PowerpointColor, PowerpointRegular, ProjectRegular, SharepointColor, SharepointRegular, TeamsColor, VisioRegular, WordColor, WordRegular } from "@fluentui/react-brand-icons";
// Custom svgs
import { BasicPlanLogo as BasicPlanLogoSvg } from "./svgs/BasicPlanLogo";
import { CheckmarkCircleDark as CheckmarkCircleDarkSvg } from "./svgs/CheckmarkCircleDark";
import { CheckmarkCircleLight as CheckmarkCircleLightSvg } from "./svgs/CheckmarkCircleLight";
import { CircleSparkle as CircleSparkleSvg } from "./svgs/CircleSparkle";
import { EmptyAttachmentLogo as EmptyAttachmentLogoSvg } from "./svgs/EmptyAttachmentLogo";
import { EmptyAttachmentLogoDarkMode as EmptyAttachmentLogoDarkModeSvg } from "./svgs/EmptyAttachmentLogoDarkMode";
import { ExcelFile as ExcelFileSvg } from "./svgs/ExcelFile";
import { FormsLogo as FormsLogoSvg } from "./svgs/FormsLogo";
import { FormsLogoFilled as FormsLogoFilledSvg } from "./svgs/FormsLogoFilled";
import { NoFlaggedEmail as NoFlaggedEmailSvg } from "./svgs/NoFlaggedEmail";
import { NoFlaggedEmailDarkMode as NoFlaggedEmailDarkModeSvg } from "./svgs/NoFlaggedEmailDarkMode";
import { NoTasksDark as NoTasksDarkSvg } from "./svgs/NoTasksDark";
import { NoTasksLight as NoTasksLightSvg } from "./svgs/NoTasksLight";
import { PdfFile as PdfFileSvg } from "./svgs/PdfFile";
import { PlannerLogo as PlannerLogoSvg } from "./svgs/PlannerLogo";
import { PlannerLogoOutline as PlannerLogoOutlineSvg } from "./svgs/PlannerLogoOutline";
import { PortfolioLogo as PortfolioLogoSvg } from "./svgs/PortfolioLogo";
import { PowerPointFile as PowerPointFileSvg } from "./svgs/PowerPointFile";
import { PremiumPlanLogo as PremiumPlanLogoSvg } from "./svgs/PremiumPlanLogo";
import { ProjectManagerSquircleLogo as ProjectManagerSquircleLogoSvg } from "./svgs/ProjectManagerAgentSquircle";
import { ResizeArrow as ResizeArrowSvg } from "./svgs/ResizeArrow";
import { RocketSparkle as RocketSparkleSvg } from "./svgs/RocketSparkle";
import { SparkleFilled as SparkleFilledSvg } from "./svgs/SparkleFilled";
import { StarHeartDark as StarHeartDarkSvg } from "./svgs/StarHeartDark";
import { StarHeartLight as StarHeartLightSvg } from "./svgs/StarHeartLight";
import { Trophy as TrophySvg } from "./svgs/Trophy";
import { WordFile as WordFileSvg } from "./svgs/WordFile";
// Utilities
import { wrapIconWithStyles } from "./helpers";
export const Add = wrapIconWithStyles(AddRegular);
export const AddSmall = wrapIconWithStyles(AddRegular, {
    fontSize: "16px"
});
export const AppsList = wrapIconWithStyles(AppsListRegular);
export const Assign = wrapIconWithStyles(PersonAddRegular);
export const AssignTeam = wrapIconWithStyles(PeopleTeamAddRegular);
export const BarChart = wrapIconWithStyles(DataBarHorizontalRegular);
export const Blocked = wrapIconWithStyles(SubtractRegular);
export const Book = wrapIconWithStyles(BookFilled);
export const BoardSplitFilled = wrapIconWithStyles(BoardSplitFilledFluentIcon);
export const BoardSplit = wrapIconWithStyles(BoardSplitRegular);
export const Calendar = wrapIconWithStyles(CalendarRegularFluentIcon);
export const CalendarFilled = wrapIconWithStyles(CalendarFilledFluentIcon);
export const CalendarDayFilled = wrapIconWithStyles(CalendarDayFilledFluentIcon);
export const CalendarEmptyFilled = wrapIconWithStyles(CalendarEmptyFilledFluentIcon);
export const CalendarTodayFilled = wrapIconWithStyles(CalendarTodayFilledFluentIcon);
export const CalendarWorkWeekFilled = wrapIconWithStyles(CalendarWorkWeekFilledFluentIcon);
export const CalendarPerson = wrapIconWithStyles(CalendarPersonRegular, {
    fontSize: "24px"
});
export const CalendarRegular = wrapIconWithStyles(CalendarRegularFluentIcon);
export const CalendarAdd = wrapIconWithStyles(CalendarAddRegular);
export const Clock = wrapIconWithStyles(ClockRegular);
export const ClipboardLink = wrapIconWithStyles(ClipboardLinkRegular);
export const ClipboardLinkFilled = wrapIconWithStyles(ClipboardLinkFilledFluentIcon);
export const ClipboardNote = wrapIconWithStyles(ClipboardNoteRegular);
export const ClipboardPaste = wrapIconWithStyles(ClipboardPasteRegular);
export const ClipboardPasteFilled = wrapIconWithStyles(ClipboardPasteFilledFluentIcon);
export const Chat = wrapIconWithStyles(ChatRegular);
export const ChatFilled = wrapIconWithStyles(ChatFilledFluentIcon);
export const CheckMark = wrapIconWithStyles(CheckmarkRegular, {
    fontSize: "16px"
});
export const CheckmarkIcon = wrapIconWithStyles(CheckmarkRegular);
export const CheckmarkIconFilled = wrapIconWithStyles(CheckmarkFilledFluentIcon);
export const CheckmarkFilledSmall = wrapIconWithStyles(Checkmark16Filled);
export const ChevronDown = wrapIconWithStyles(ChevronDownRegular);
export const ChevronDownSmall = wrapIconWithStyles(ChevronDownRegular, {
    fontSize: "16px"
});
export const ChevronDownExtraSmall = wrapIconWithStyles(ChevronDownRegular, {
    fontSize: "12px"
});
export const ChevronLeft = wrapIconWithStyles(ChevronLeftRegular);
export const ChevronLeftFilled = wrapIconWithStyles(ChevronLeftFilledFluentIcon);
export const ChevronLeftSmall = wrapIconWithStyles(ChevronLeftRegular, {
    fontSize: "16px"
});
export const ChevronLeftExtraSmall = wrapIconWithStyles(ChevronLeftRegular, {
    fontSize: "12px"
});
export const ChevronLeftLarge = wrapIconWithStyles(ChevronLeftRegular, {
    fontSize: "28px"
});
export const ChevronRight = wrapIconWithStyles(ChevronRightRegular);
export const ChevronRightFilled = wrapIconWithStyles(ChevronRightFilledFluentIcon);
export const ChevronRightSmall = wrapIconWithStyles(ChevronRightRegular, {
    fontSize: "16px"
});
export const ChevronRightExtraSmall = wrapIconWithStyles(ChevronRightRegular, {
    fontSize: "12px"
});
export const ChevronRightLarge = wrapIconWithStyles(ChevronRightRegular, {
    fontSize: "28px"
});
export const ChevronUp = wrapIconWithStyles(ChevronUpRegular);
export const ColorFill = wrapIconWithStyles(ColorFillRegular);
export const ColorFillFilledIcon = wrapIconWithStyles(ColorFillFilled);
export const ColorPalette = wrapIconWithStyles(ColorFilled);
export const CommentMultiple = wrapIconWithStyles(CommentMultipleRegular);
export const Completed = wrapIconWithStyles(CheckmarkCircleRegular);
export const Copy = wrapIconWithStyles(CopyRegular);
export const CopyFilled = wrapIconWithStyles(CopyFilledFluentIcon);
export const CopyAdd = wrapIconWithStyles(CopyAddRegular);
export const CopyAddFilled = wrapIconWithStyles(CopyAddFilledFluentIcon);
export const CopySelect = wrapIconWithStyles(CopySelectRegular);
export const CopySelectFilled = wrapIconWithStyles(CopySelectFilledFluentIcon);
export const Cut = wrapIconWithStyles(CutRegular);
export const CutFilled = wrapIconWithStyles(CutFilledFluentIcon);
export const Delete = wrapIconWithStyles(DeleteRegular);
export const DeleteFilled = wrapIconWithStyles(DeleteFilledFluentIcon);
export const DeleteSmall = wrapIconWithStyles(DeleteRegular, {
    fontSize: "16px"
});
export const Dismiss = wrapIconWithStyles(DismissRegular);
export const DismissFilled = wrapIconWithStyles(DismissFilledFluentIcon);
export const DismissSmall = wrapIconWithStyles(DismissRegular, {
    fontSize: "16px"
});
export const DismissExtraSmall = wrapIconWithStyles(DismissRegular, {
    fontSize: "12px"
});
export const DismissCircle = wrapIconWithStyles(DismissCircleRegular);
export const DismissCircleFilled = wrapIconWithStyles(DismissCircleFilledFluentIcon);
export const Diamond = wrapIconWithStyles(PremiumRegular);
export const DiamondFilled = wrapIconWithStyles(PremiumFilledFluentIcon);
export const Divider = wrapIconWithStyles(DividerTallRegular, {
    fontSize: "16px"
});
export const Dot = wrapIconWithStyles(CircleSmallFilled);
export const Down = wrapIconWithStyles(ArrowDownRegular);
export const DownSmall = wrapIconWithStyles(ArrowDownRegular, {
    fontSize: "16px"
});
export const ColumnArrowRightIcon = wrapIconWithStyles(ColumnArrowRightRegular);
export const ColumnArrowRightFilled = wrapIconWithStyles(ColumnArrowRightFilledFluentIcon);
export const ColumnArrowLeftIcon = wrapIconWithStyles(ColumnArrowRightRegular, {
    style: {
        transform: "scaleX(-1)"
    }
});
export const ColumnArrowLeftFilled = wrapIconWithStyles(ColumnArrowRightFilledFluentIcon, {
    style: {
        transform: "scaleX(-1)"
    }
});
export const ColumnTripleEdit = wrapIconWithStyles(ColumnTripleEditRegular);
export const ColumnTripleEditFilledIcon = wrapIconWithStyles(ColumnTripleEditFilled);
export const Expand = wrapIconWithStyles(ArrowMaximizeRegular);
export const ExpandHorizontal = wrapIconWithStyles(ArrowExpandRegular, {
    style: {
        transform: "rotate(90deg)"
    }
});
export const ArrowExpand = wrapIconWithStyles(ArrowExpandRegular);
export const ArrowExpandFilled = wrapIconWithStyles(ArrowExpandFilledFluentIcon);
export const ArrowCollapseAll = wrapIconWithStyles(ArrowCollapseAllRegular);
export const ArrowCollapseAllFilled = wrapIconWithStyles(ArrowCollapseAllFilledFluentIcon);
export const Edit = wrapIconWithStyles(EditRegular);
export const EditFilled = wrapIconWithStyles(EditFilledFluentIcon);
export const Error = wrapIconWithStyles(ErrorCircleRegular);
export const ErrorSmall = wrapIconWithStyles(ErrorCircleRegular, {
    fontSize: "12px"
});
export const EmojiAdd = wrapIconWithStyles(EmojiAdd20Regular);
export const EmojiAddFilled = wrapIconWithStyles(EmojiAdd20Filled);
export const EyeHide = wrapIconWithStyles(EyeRegular);
export const EyeOff = wrapIconWithStyles(EyeOffRegular);
export const EyeOffFilled = wrapIconWithStyles(EyeOffFilledFluentIcon);
export const FavoriteStar = wrapIconWithStyles(StarRegular);
export const FavoriteStarFilled = wrapIconWithStyles(StarFilled);
export const Filter = wrapIconWithStyles(FilterRegular);
export const FilterFilled = wrapIconWithStyles(FilterFilledFluentIcon);
export const FolderPeople = wrapIconWithStyles(FolderPeopleRegular);
export const Gantt = wrapIconWithStyles(GanttChartRegular, {
    fontSize: "24px"
});
export const GanttFilled = wrapIconWithStyles(GanttChartFilled, {
    fontSize: "24px"
});
export const GanttChart = wrapIconWithStyles(GanttChartRegular);
export const GanttChartFilledIcon = wrapIconWithStyles(GanttChartFilled);
export const Goals = wrapIconWithStyles(TrophyRegular);
export const GoalsFilled = wrapIconWithStyles(TrophyFilled);
export const Group = wrapIconWithStyles(PeopleCommunityRegular);
export const Home = wrapIconWithStyles(HomeRegular);
export const Image = wrapIconWithStyles(ImageRegular);
export const InfoLarge = wrapIconWithStyles(InfoRegular, {
    fontSize: "24px"
});
export const Info = wrapIconWithStyles(InfoRegular);
export const InfoFilled = wrapIconWithStyles(InfoFilledFluentIcon);
export const InfoSmall = wrapIconWithStyles(InfoRegular, {
    fontSize: "16px"
});
export const InsertBetween = wrapIconWithStyles(Insert20Regular);
export const Left = wrapIconWithStyles(ArrowLeftRegular);
export const Link = wrapIconWithStyles(LinkRegular);
export const LinkFilled = wrapIconWithStyles(LinkFilledFluentIcon);
export const LinkLarge = wrapIconWithStyles(LinkRegular, {
    fontSize: "28px"
});
export const LinkDismiss = wrapIconWithStyles(LinkDismissRegular, {
    fontSize: "16px"
});
export const LinkMultiple = wrapIconWithStyles(LinkMultipleRegular);
export const LinkMultipleFilled = wrapIconWithStyles(LinkMultipleFilledFluentIcon);
export const Lock = wrapIconWithStyles(LockClosedRegular);
export const LockFilled = wrapIconWithStyles(LockClosedFilled);
export const LockShield = wrapIconWithStyles(LockShieldRegular);
export const More = wrapIconWithStyles(MoreHorizontalRegular);
export const MoreFilled = wrapIconWithStyles(MoreHorizontalFilled);
export const MoreVertical = wrapIconWithStyles(MoreVerticalRegular);
export const Move = wrapIconWithStyles(ArrowRightRegular);
export const MoveFilled = wrapIconWithStyles(ArrowRightFilled);
export const MyDayFilled = wrapIconWithStyles(WeatherSunnyFilled);
export const MyDayRegularSmall = wrapIconWithStyles(WeatherSunnyRegular, {
    fontSize: "16px"
});
export const MyDayRegular = wrapIconWithStyles(WeatherSunnyRegular);
export const MyPlansFilled = wrapIconWithStyles(GridFilled);
export const MyPlansRegular = wrapIconWithStyles(GridRegular);
export const MyTasksFilled = wrapIconWithStyles(HomeCheckmarkFilled);
export const MyTasksRegular = wrapIconWithStyles(HomeCheckmarkRegular);
export const Navigation = wrapIconWithStyles(NavigationRegular);
export const OpenInNewWindow = wrapIconWithStyles(OpenRegular);
export const OpenInNewWindowFilled = wrapIconWithStyles(OpenFilledFluentIcon);
export const Options = wrapIconWithStyles(OptionsRegular, {
    fontSize: "20px"
});
export const PaintBucket = wrapIconWithStyles(PaintBucketRegular);
export const PaintBucketFilledIcon = wrapIconWithStyles(PaintBucketFilled);
export const PanelLeftContract = wrapIconWithStyles(PanelLeftContractRegular);
export const PanelLeftContractFilled = wrapIconWithStyles(PanelLeftContractFilledFluentIcon);
export const PanelLeftExpand = wrapIconWithStyles(PanelLeftExpandRegular);
export const PanelLeftExpandFilled = wrapIconWithStyles(PanelLeftExpandFilledFluentIcon);
export const PanelRightContract = wrapIconWithStyles(PanelRightContractRegular);
export const PanelRightExpand = wrapIconWithStyles(PanelRightExpandRegular);
export const Pdf = wrapIconWithStyles(DocumentPdfRegular);
export const People = wrapIconWithStyles(PeopleRegular);
export const PeopleFilled = wrapIconWithStyles(PeopleFilledFluentIcon);
export const PeopleLarge = wrapIconWithStyles(PeopleRegular, {
    fontSize: "28px"
});
export const Pause = wrapIconWithStyles(PauseRegular);
export const Person = wrapIconWithStyles(PersonRegular);
export const PersonFilled = wrapIconWithStyles(PersonFilledFluentIcon);
export const PersonArrowLeft = wrapIconWithStyles(PersonArrowLeftRegular);
export const PersonSubtract = wrapIconWithStyles(PersonSubtractRegular);
export const PersonArrowLeftFilled = wrapIconWithStyles(PersonArrowLeftFilledFluentIcon);
export const PersonFeedback = wrapIconWithStyles(PersonFeedbackRegular);
export const PersonFeedbackFilled = wrapIconWithStyles(PersonFeedbackFilledFluentIcon);
export const Phone = wrapIconWithStyles(PhoneRegular);
export const Pin = wrapIconWithStyles(PinRegular);
export const PinFilled = wrapIconWithStyles(PinFilledFluentIcon);
export const PinOff = wrapIconWithStyles(PinOffRegular);
export const PinOffFilled = wrapIconWithStyles(PinOffFilledFluentIcon);
export const Play = wrapIconWithStyles(PlayRegular);
export const PlugConnected = wrapIconWithStyles(PlugConnectedRegular);
export const PlugDisconnected = wrapIconWithStyles(PlugDisconnectedRegular);
export const PlugDisconnectedFilled = wrapIconWithStyles(PlugDisconnectedFilledFluentIcon);
export const PlanHub = wrapIconWithStyles(CircleRegular);
export const Question = wrapIconWithStyles(QuestionRegular);
export const QuestionCircle = wrapIconWithStyles(QuestionCircleRegular);
export const QuestionCircleFill = wrapIconWithStyles(QuestionCircleFilled);
export const RectanglePortrait = wrapIconWithStyles(RectanglePortraitRegular);
export const Recents = wrapIconWithStyles(ClockRegular);
export const Recurrence = wrapIconWithStyles(ArrowRepeatAllRegular);
export const RecurrenceSmall = wrapIconWithStyles(ArrowRepeatAllRegular, {
    fontSize: "16px"
});
export const TaskHistory = wrapIconWithStyles(PenSync20Regular);
export const TaskHistoryFilled = wrapIconWithStyles(PenSync20Filled);
export const ReOrderDotsVertical = wrapIconWithStyles(ReOrderDotsVerticalRegular, {
    fontSize: "16px"
});
export const ReOrderDotsVerticalFilled = wrapIconWithStyles(ReOrderDotsVerticalFilledFluentIcon, {
    fontSize: "16px"
});
export const RefreshApp = wrapIconWithStyles(ArrowClockwiseRegular);
export const RefreshAppFilled = wrapIconWithStyles(ArrowClockwiseFilledFluentIcon);
export const Retry = wrapIconWithStyles(ArrowClockwiseRegular, {
    fontSize: "16px"
});
export const RevToggle = wrapIconWithStyles(ArrowResetRegular);
export const Save = wrapIconWithStyles(SaveRegular);
export const SaveFilled = wrapIconWithStyles(SaveFilledFluentIcon);
export const Send = wrapIconWithStyles(SendRegular);
export const SendFilled = wrapIconWithStyles(SendFilledFluentIcon);
export const ArrowSortDownLines = wrapIconWithStyles(ArrowSortDownLinesRegular);
export const ArrowSortDownLinesFilled = wrapIconWithStyles(ArrowSortDownLinesFilledFluentIcon);
export const ArrowSortUpLines = wrapIconWithStyles(ArrowSortUpLinesRegular);
export const ArrowSortUpLinesFilled = wrapIconWithStyles(ArrowSortUpLinesFilledFluentIcon);
export const ArrowSort = wrapIconWithStyles(ArrowSortRegular);
export const ReOrder = wrapIconWithStyles(ReOrderRegular);
export const TextSortAscending = wrapIconWithStyles(TextSortAscendingRegular);
export const CalendarClock = wrapIconWithStyles(CalendarClockRegular);
export const CalendarDate = wrapIconWithStyles(CalendarDateRegular);
export const GroupList = wrapIconWithStyles(GroupListRegular);
export const GroupListFilled = wrapIconWithStyles(GroupListFluentIconFilled);
export const Search = wrapIconWithStyles(SearchRegular);
export const SearchFilled = wrapIconWithStyles(SearchFilledFluentIcon);
export const Settings = wrapIconWithStyles(SettingsRegular);
export const Status = wrapIconWithStyles(Status20Regular);
export const StatusFilled = wrapIconWithStyles(Status20Filled);
export const StopSmall = wrapIconWithStyles(StopRegular, {
    fontSize: "16px"
});
export const Tag = wrapIconWithStyles(TagRegular);
export const TagFilled = wrapIconWithStyles(TagFilledFluentIcon);
export const TagEdit = wrapIconWithStyles(TagEditRegular);
export const TagEditFilled = wrapIconWithStyles(TagEditFilledFluentIcon);
export const TargetArrow = wrapIconWithStyles(TargetArrowRegular);
export const TargetArrowFilled = wrapIconWithStyles(TargetArrowFilledFluentIcon);
export const TaskList = wrapIconWithStyles(TaskListLtrRegular);
export const TaskListFilled = wrapIconWithStyles(TaskListLtrFilled);
export const TaskListAdd = wrapIconWithStyles(TaskListAddRegular);
export const TaskListAddFilled = wrapIconWithStyles(TaskListAddFilledFluentIcon);
export const TaskListSquareLtr = wrapIconWithStyles(TaskListSquareLtrRegular);
export const Taskboard = wrapIconWithStyles(BoardRegular);
export const TaskboardFilled = wrapIconWithStyles(BoardFilled);
export const Flag = wrapIconWithStyles(FlagRegular);
export const Keyboard123 = wrapIconWithStyles(Keyboard123Regular);
export const Keyboard123Filled = wrapIconWithStyles(Keyboard123FilledFluentIcon);
export const Text = wrapIconWithStyles(TextTRegular);
export const TextFilled = wrapIconWithStyles(TextTFilledFluentIcon);
export const TextField = wrapIconWithStyles(TextFieldRegular);
export const TextIndentDecreaseLtr = wrapIconWithStyles(TextIndentDecreaseLtrRegular);
export const TextIndentDecreaseLtrFilled = wrapIconWithStyles(TextIndentDecreaseLtrFilledFluentIcon);
export const TextPercent = wrapIconWithStyles(TextPercentRegular);
export const TextPercentFilled = wrapIconWithStyles(TextPercentFilledFluentIcon);
export const SubtractSquare = wrapIconWithStyles(SubtractSquareRegular);
export const SubtractSquareFilled = wrapIconWithStyles(SubtractSquareFilledFluentIcon);
export const ArrowTurnDownRight = wrapIconWithStyles(ArrowTurnDownRightRegular);
export const ArrowTurnDownRightFilled = wrapIconWithStyles(ArrowTurnDownRightFilledFluentIcon);
export const ArrowTurnDownLeft = wrapIconWithStyles(ArrowTurnDownLeftRegular);
export const ArrowTurnDownLeftFilled = wrapIconWithStyles(ArrowTurnDownLeftFilledFluentIcon);
export const ArrowExportLtr = wrapIconWithStyles(ArrowExportLtrRegular);
export const ArrowExportLtrFilled = wrapIconWithStyles(ArrowExportLtrFilledFluentIcon);
export const ArrowExportRtl = wrapIconWithStyles(ArrowExportRtlRegular);
export const ArrowExportRtlFilled = wrapIconWithStyles(ArrowExportRtlFilledFluentIcon);
export const Unknown = wrapIconWithStyles(QuestionCircleRegular);
export const Upload = wrapIconWithStyles(ArrowUploadRegular);
export const UpSmall = wrapIconWithStyles(ArrowUpRegular, {
    fontSize: "16px"
});
export const ApprovalsAppFilled = wrapIconWithStyles(ApprovalsAppFilledFluentIcon);
export const SquareDismiss = wrapIconWithStyles(SquareDismissRegular);
export const Table = wrapIconWithStyles(TableRegular);
export const TableFilled = wrapIconWithStyles(TableFilledFluentIcon);
export const TextEditStyle = wrapIconWithStyles(TextEditStyleRegular);
export const TextEditStyleFilled = wrapIconWithStyles(TextEditStyleFilledFluentIcon);
export const Chart = wrapIconWithStyles(ChartMultipleRegular);
export const ChartFilled = wrapIconWithStyles(ChartMultipleFilled);
export const EditPerson = wrapIconWithStyles(EditPersonRegular);
export const Attach = wrapIconWithStyles(AttachRegular);
export const ArrowCounterclockwise = wrapIconWithStyles(ArrowCounterclockwiseRegular);
export const ArrowUndo = wrapIconWithStyles(ArrowUndoRegular);
export const ArrowCounterclockwiseFilled = wrapIconWithStyles(ArrowCounterclockwiseFilledFluentIcon);
export const AddAgent = wrapIconWithStyles(BotAddRegular);
export const GhostTaskStatusSmall = wrapIconWithStyles(CircleHintHalfVerticalRegular, {
    fontSize: "16px"
});
export const DocumentTextExtract = wrapIconWithStyles(DocumentTextExtractRegular);
export const DocumentTextExtractFilled = wrapIconWithStyles(DocumentTextExtractFilledFluentIcon);
export const Prohibited = wrapIconWithStyles(ProhibitedRegular);
export const ProhibitedFilled = wrapIconWithStyles(ProhibitedFilledFluentIcon);
export const ProhibitedSmall = wrapIconWithStyles(ProhibitedRegular, {
    fontSize: "16px"
});
// Shield icons
export const Shield = wrapIconWithStyles(ShieldRegular);
export const ShieldFilled = wrapIconWithStyles(ShieldFilledFluentIcon);
export const ShieldError = wrapIconWithStyles(ShieldErrorRegular);
export const ShieldLock = wrapIconWithStyles(ShieldLockRegular);
export const ShieldLockFilled = wrapIconWithStyles(ShieldLockFilledFluentIcon);
export const ShieldQuestion = wrapIconWithStyles(ShieldQuestionRegular);
// Task Status icons
export const StatusNotStarted = wrapIconWithStyles(CircleRegular);
export const StatusInProgress = wrapIconWithStyles(CircleHalfFillRegular);
export const StatusInProgressFilled = wrapIconWithStyles(CircleHalfFillFilledFluentIcon);
export const StatusComplete = wrapIconWithStyles(CheckmarkCircleFilled);
export const StatusNotStartedDashed = wrapIconWithStyles(CircleHintRegular);
export const StatusPaused = wrapIconWithStyles(PauseCircleRegular);
export const StatusPending = wrapIconWithStyles(ClockRegular);
export const StatusBlocked = wrapIconWithStyles(ProhibitedRegular);
export const StatusStopped = wrapIconWithStyles(RecordStopRegular);
export const StatusAtRisk = wrapIconWithStyles(ErrorCircleFilled);
export const StatusNotDoing = wrapIconWithStyles(SubtractCircleFilled);
export const StatusDeferred = wrapIconWithStyles(ArrowCircleRightFilled);
export const StatusArchived = wrapIconWithStyles(ArchiveRegular);
export const StatusNotStartedSmall = wrapIconWithStyles(CircleRegular, {
    fontSize: "16px"
});
export const StatusInProgressSmall = wrapIconWithStyles(CircleHalfFillRegular, {
    fontSize: "16px"
});
export const StatusCompleteSmall = wrapIconWithStyles(CheckmarkCircleFilled, {
    fontSize: "16px"
});
export const StatusCompleteSmallNoFill = wrapIconWithStyles(CheckmarkCircleRegular, {
    fontSize: "16px"
});
// Priority icons
export const PriorityUrgent = wrapIconWithStyles(AlertUrgentFilled);
export const PriorityUrgentSmall = wrapIconWithStyles(AlertUrgentFilled, {
    fontSize: "16px"
});
export const PriorityImportant = wrapIconWithStyles(ImportantFilled);
export const PriorityImportantSmall = wrapIconWithStyles(ImportantFilled, {
    fontSize: "16px"
});
export const PriorityMedium = wrapIconWithStyles(CircleSmallFilled);
export const PriorityMediumSmall = wrapIconWithStyles(CircleSmallFilled, {
    fontSize: "16px"
});
export const PriorityLow = wrapIconWithStyles(ArrowDownRegular);
export const PriorityLowSmall = wrapIconWithStyles(ArrowDownRegular, {
    fontSize: "16px"
});
export const PriorityUrgentNoFill = wrapIconWithStyles(AlertUrgentRegular);
export const PriorityImportantNoFill = wrapIconWithStyles(ImportantRegular);
export const PriorityMediumNoFill = wrapIconWithStyles(CircleSmallRegular);
// Small icons (for task card indicators)
export const AttachSmall = wrapIconWithStyles(AttachRegular, {
    fontSize: "16px"
});
export const CalendarSmall = wrapIconWithStyles(CalendarRegularFluentIcon, {
    fontSize: "16px"
});
export const ChatSmall = wrapIconWithStyles(ChatRegular, {
    fontSize: "16px"
});
export const ChecklistSmall = wrapIconWithStyles(CheckmarkCircleRegular, {
    fontSize: "16px"
});
export const AppsSmall = wrapIconWithStyles(AppsRegular, {
    fontSize: "16px"
});
export const GoalsSmall = wrapIconWithStyles(TrophyRegular, {
    fontSize: "16px"
});
// Due Date icons
export const DueDateLate = wrapIconWithStyles(WarningRegular);
export const DueDateToday = wrapIconWithStyles(CalendarTodayRegular);
export const DueDateTomorrow = wrapIconWithStyles(CalendarDayRegular);
export const DueDateWeek = wrapIconWithStyles(CalendarWorkWeekRegular);
export const DueDateNoDate = wrapIconWithStyles(CalendarEmptyRegular);
export const DueDateLateFilled = wrapIconWithStyles(WarningFilledFluentIcon);
export const DueDateTodayFilled = wrapIconWithStyles(CalendarTodayFilledFluentIcon);
export const DueDateTomorrowFilled = wrapIconWithStyles(CalendarDayFilledFluentIcon);
export const DueDateWeekFilled = wrapIconWithStyles(CalendarWorkWeekFilledFluentIcon);
export const DueDateNoDateFilled = wrapIconWithStyles(CalendarEmptyFilledFluentIcon);
// Status Late icon (CalendarClock) - used in the Status filter menu for the "Late" option
export const StatusLate = wrapIconWithStyles(CalendarClockRegular);
export const StatusLateFilled = wrapIconWithStyles(CalendarClockFilledFluentIcon);
// File icons
export const WordLogo = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(WordRegular, props)));
export const ExcelLogo = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(ExcelRegular, props)));
export const ExcelLogoFilled = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(ExcelFilled, props)));
export const OneNoteLogo = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(OnenoteRegular, props)));
export const OutlookLogo = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(OutlookRegular, props)));
export const PowerPointLogo = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(PowerpointRegular, props)));
export const ProjectLogo = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(ProjectRegular, props)));
export const FormsLogo = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(FormsLogoSvg, props)));
export const VisioLogo = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(VisioRegular, props)));
export const FormsLogoFilled = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(FormsLogoFilledSvg, props)));
// OneDriveList icons
export const OpenFolder = wrapIconWithStyles(FolderOpenRegular);
export const Folder = wrapIconWithStyles(FolderRegular);
export const Document = wrapIconWithStyles(DocumentRegular);
export const DocumentBulletList = wrapIconWithStyles(DocumentBulletListRegular);
export const DocumentBulletListFilled = wrapIconWithStyles(DocumentBulletListFilledFluentIcon);
// Portfolio icons
export const PortfolioStatus = wrapIconWithStyles(CircleFilled);
export const PortfolioFolder = wrapIconWithStyles(FolderRegular);
export const PortfolioFolderFilled = wrapIconWithStyles(FolderFilled);
export const PortfolioFolderList = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(PortfolioLogoSvg, props)));
// CreatePlan icons
export const Timeline = wrapIconWithStyles(TimelineRegular);
export const List = wrapIconWithStyles(ListRegular);
export const Copilot = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(CopilotRegular, props)));
export const ProjectManagerIcon = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(PlannerLogoSvg, props)));
export const BasicPlanIcon = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(BasicPlanLogoSvg, props)));
export const PremiumPlanIcon = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(PremiumPlanLogoSvg, props)));
// Project Home Icons - Old Rocket icons (kept for backward compatibility)
export const AddCircle = wrapIconWithStyles(AddCircleRegular);
export const AddCircleSmall = wrapIconWithStyles(AddCircleRegular, {
    fontSize: "16px"
});
export const Loop = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(LoopRegular, props)));
export const RocketLogoFilled = wrapIconWithStyles(RocketFilled);
export const RocketLogo = wrapIconWithStyles(RocketRegular);
export const RocketLogoSmall = wrapIconWithStyles(RocketRegular, {
    fontSize: "16px"
});
export const RocketLogoFilledLarge = wrapIconWithStyles(RocketFilled, {
    fontSize: "24px"
});
export const ProjectManagerSquircleLogo = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(ProjectManagerSquircleLogoSvg, props)));
export const RocketSparkle = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(RocketSparkleSvg, props)));
// New Planner icons
export const PlannerLogoFilled = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(PlannerLogoSvg, props)));
export const PlannerLogoOutline = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(PlannerLogoOutlineSvg, props)));
export const PlannerLogoOutlineSmall = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(PlannerLogoOutlineSvg, props)), {
    fontSize: "16px"
});
export const PlannerLogoFilledLarge = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(PlannerLogoSvg, props)), {
    fontSize: "24px"
});
export const Globe = wrapIconWithStyles(GlobeRegular);
// AI Task Icons
export const CircleSparkle = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(CircleSparkleSvg, props)));
export const Sparkle = wrapIconWithStyles(SparkleFilledFluentIcon);
export const SparkleRegular = wrapIconWithStyles(SparkleRegularFluentIcon);
export const SparkleFilled = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(SparkleFilledSvg, props)));
//Status Report Icons
export const Share = wrapIconWithStyles(ShareRegular);
export const ShareFilled = wrapIconWithStyles(ShareFilledFluentIcon);
export const Sharepoint = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(SharepointRegular, props)));
// Attachment Empty State Icons
export const EmptyAttachmentLogo = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(EmptyAttachmentLogoSvg, props)));
export const EmptyAttachmentLogoDarkMode = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(EmptyAttachmentLogoDarkModeSvg, props)));
// Goal Icons
export const TrophyIcon = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(TrophySvg, props)));
// File Icons
export const ExcelFile = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(ExcelFileSvg, props)));
export const PdfFile = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(PdfFileSvg, props)));
export const PowerPointFile = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(PowerPointFileSvg, props)));
export const WordFile = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(WordFileSvg, props)));
// My Tasks Empty state Icons
export const NoTasksLight = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(NoTasksLightSvg, props)));
export const NoTasksDark = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(NoTasksDarkSvg, props)));
export const CheckmarkCircleDark = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(CheckmarkCircleDarkSvg, props)));
export const CheckmarkCircleLight = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(CheckmarkCircleLightSvg, props)));
export const StarHeartDark = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(StarHeartDarkSvg, props)));
export const StarHeartLight = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(StarHeartLightSvg, props)));
// Flagged Email Empty state Icons
export const NoFlaggedEmail = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(NoFlaggedEmailSvg, props)));
export const NoFlaggedEmailDarkMode = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(NoFlaggedEmailDarkModeSvg, props)));
// Brand colored icons
export const SharepointColorIcon = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(SharepointColor, props)));
export const TeamsColorIcon = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(TeamsColor, props)));
export const LoopColorIcon = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(LoopColor, props)));
export const ExcelColorIcon = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(ExcelColor, props)));
export const WordColorIcon = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(WordColor, props)));
export const PowerpointColorIcon = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(PowerpointColor, props)));
export const ExcelColorIconLarge = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(ExcelColor, props)), {
    fontSize: "28px"
});
export const WordColorIconLarge = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(WordColor, props)), {
    fontSize: "28px"
});
export const PowerpointColorIconLarge = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(PowerpointColor, props)), {
    fontSize: "28px"
});
export const PdfLarge = wrapIconWithStyles(DocumentPdfRegular, {
    fontSize: "28px"
});
export const SharepointColorIconLarge = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(SharepointColor, props)), {
    fontSize: "28px"
});
export const TeamsColorIconLarge = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(TeamsColor, props)), {
    fontSize: "28px"
});
export const LoopColorIconLarge = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(LoopColor, props)), {
    fontSize: "28px"
});
// Gantt Icons
export const ResizeArrow = wrapIconWithStyles(wrapSvgAsFluentIcon((props)=>/*#__PURE__*/ React.createElement(ResizeArrowSvg, props)));
// BundledIcons
export const ArrowClockwiseBundled = bundleIcon(RefreshAppFilled, RefreshApp);
export const ArrowCollapseAllBundled = bundleIcon(ArrowCollapseAllFilled, ArrowCollapseAll);
export const ArrowExpandBundled = bundleIcon(ArrowExpandFilled, ArrowExpand);
export const ArrowSortDownLinesBundled = bundleIcon(ArrowSortDownLinesFilled, ArrowSortDownLines);
export const ArrowSortUpLinesBundled = bundleIcon(ArrowSortUpLinesFilled, ArrowSortUpLines);
export const BoardSplitBundled = bundleIcon(BoardSplitFilled, BoardSplit);
export const CalendarBundled = bundleIcon(CalendarFilled, CalendarRegular);
export const ColumnTripleEditBundled = bundleIcon(ColumnTripleEditFilledIcon, ColumnTripleEdit);
export const ChartBundled = bundleIcon(ChartFilled, Chart);
export const ChevronLeftBundled = bundleIcon(ChevronLeftFilled, ChevronLeft);
export const ChevronRightBundled = bundleIcon(ChevronRightFilled, ChevronRight);
export const ColumnArrowLeftBundled = bundleIcon(ColumnArrowLeftFilled, ColumnArrowLeftIcon);
export const ColumnArrowRightBundled = bundleIcon(ColumnArrowRightFilled, ColumnArrowRightIcon);
export const ClipboardLinkBundled = bundleIcon(ClipboardLinkFilled, ClipboardLink);
export const ColorFillBundled = bundleIcon(ColorFillFilledIcon, ColorFill);
export const ColorPaletteBundled = bundleIcon(ColorFilled, ColorRegular);
export const CopyAddBundled = bundleIcon(CopyAddFilled, CopyAdd);
export const CopyBundled = bundleIcon(CopyFilled, Copy);
export const DeleteBundled = bundleIcon(DeleteFilled, Delete);
export const DismissBundled = bundleIcon(DismissFilled, Dismiss);
export const DocumentTextExtractBundled = bundleIcon(DocumentTextExtractFilled, DocumentTextExtract);
export const DueDateLateBundled = bundleIcon(DueDateLateFilled, DueDateLate);
export const DueDateNoDateBundled = bundleIcon(DueDateNoDateFilled, DueDateNoDate);
export const DueDateTodayBundled = bundleIcon(DueDateTodayFilled, DueDateToday);
export const DueDateTomorrowBundled = bundleIcon(DueDateTomorrowFilled, DueDateTomorrow);
export const DueDateWeekBundled = bundleIcon(DueDateWeekFilled, DueDateWeek);
export const EditBundled = bundleIcon(EditFilled, Edit);
export const ExcelLogoBundled = bundleIcon(ExcelLogoFilled, ExcelLogo);
export const EmojiAddBundled = bundleIcon(EmojiAddFilled, EmojiAdd);
export const EyeOffBundled = bundleIcon(EyeOffFilled, EyeOff);
export const FilterBundled = bundleIcon(FilterFilled, Filter);
export const FlagBundled = bundleIcon(FlagFilled, Flag);
export const GoalsBundled = bundleIcon(GoalsFilled, Goals);
export const GroupListBundled = bundleIcon(GroupListFilled, GroupList);
export const InfoBundled = bundleIcon(InfoFilled, Info);
export const Keyboard123Bundled = bundleIcon(Keyboard123Filled, Keyboard123);
export const LinkBundled = bundleIcon(LinkFilled, Link);
export const LinkMultipleBundled = bundleIcon(LinkMultipleFilled, LinkMultiple);
export const LockBundled = bundleIcon(LockFilled, Lock);
export const MoveBundled = bundleIcon(MoveFilled, Move);
export const MoreBundled = bundleIcon(MoreFilled, More);
export const MyDayBundled = bundleIcon(MyDayFilled, MyDayRegular);
export const MyPlansBundled = bundleIcon(MyPlansFilled, MyPlansRegular);
export const OpenInNewWindowBundled = bundleIcon(OpenInNewWindowFilled, OpenInNewWindow);
export const PaintBucketBundled = bundleIcon(PaintBucketFilledIcon, PaintBucket);
export const PeopleBundled = bundleIcon(PeopleFilled, People);
export const PersonArrowLeftBundled = bundleIcon(PersonArrowLeftFilled, PersonArrowLeft);
export const PersonFeedbackBundled = bundleIcon(PersonFeedbackFilled, PersonFeedback);
export const PinBundled = bundleIcon(PinFilled, Pin);
export const PinOffBundled = bundleIcon(PinOffFilled, PinOff);
export const PortfolioFolderBundled = bundleIcon(PortfolioFolderFilled, PortfolioFolder);
export const PriorityImportantBundled = bundleIcon(PriorityImportant, PriorityImportantNoFill);
export const ProhibitedBundled = bundleIcon(ProhibitedFilled, Prohibited);
export const QuestionCircleBundled = bundleIcon(QuestionCircleFill, QuestionCircle);
export const SaveBundled = bundleIcon(SaveFilled, Save);
export const SendBundled = bundleIcon(SendFilled, Send);
export const SearchBundled = bundleIcon(SearchFilled, Search);
export const ShareBundled = bundleIcon(ShareFilled, Share);
export const SparkleBundled = bundleIcon(SparkleFilledFluentIcon, SparkleRegularFluentIcon);
export const StarBundled = bundleIcon(StarFilled, StarRegular);
export const StatusBundled = bundleIcon(StatusFilled, Status);
export const StatusInProgressBundled = bundleIcon(StatusInProgressFilled, StatusInProgress);
export const StatusLateBundled = bundleIcon(StatusLateFilled, StatusLate);
export const TableBundled = bundleIcon(TableFilled, Table);
export const TagBundled = bundleIcon(TagFilled, Tag);
export const TagEditBundled = bundleIcon(TagEditFilled, TagEdit);
export const TaskBoardBundled = bundleIcon(TaskboardFilled, Taskboard);
export const TaskListBundled = bundleIcon(TaskListFilled, TaskList);
export const TextBundled = bundleIcon(TextFilled, Text);
export const TextEditStyleBundled = bundleIcon(TextEditStyleFilled, TextEditStyle);
export const TextPercentBundled = bundleIcon(TextPercentFilled, TextPercent);
export const TodayIconBundled = bundleIcon(DueDateTodayFilled, DueDateToday);
export const TemplateIcon = bundleIcon(DocumentBulletListFilled, DocumentBulletList);
export const ArrowCounterclockwiseBundled = bundleIcon(ArrowCounterclockwiseFilled, ArrowCounterclockwise);
export const CheckmarkBundled = bundleIcon(CheckmarkIconFilled, CheckmarkIcon);
export const ClipboardPasteBundled = bundleIcon(ClipboardPasteFilled, ClipboardPaste);
export const CopySelectBundled = bundleIcon(CopySelectFilled, CopySelect);
export const CutBundled = bundleIcon(CutFilled, Cut);
export const GanttBundled = bundleIcon(GanttChartFilledIcon, GanttChart);
export const PersonBundled = bundleIcon(PersonFilled, Person);
export const PlugConnectedAddBundled = bundleIcon(PlugConnectedAddFilled, PlugConnectedAddRegular);
export const PlugDisconnectedBundled = bundleIcon(PlugDisconnectedFilled, PlugDisconnected);
export const ReOrderDotsVerticalBundled = bundleIcon(ReOrderDotsVerticalFilled, ReOrderDotsVertical);
export const SubtractSquareBundled = bundleIcon(SubtractSquareFilled, SubtractSquare);
export const ArrowTurnDownRightBundled = bundleIcon(ArrowTurnDownRightFilled, ArrowTurnDownRight);
export const ArrowTurnDownLeftBundled = bundleIcon(ArrowTurnDownLeftFilled, ArrowTurnDownLeft);
export const ArrowExportLtrBundled = bundleIcon(ArrowExportLtrFilled, ArrowExportLtr);
export const ArrowExportRtlBundled = bundleIcon(ArrowExportRtlFilled, ArrowExportRtl);
export const TargetArrowBundled = bundleIcon(TargetArrowFilled, TargetArrow);
export const TaskListAddBundled = bundleIcon(TaskListAddFilled, TaskListAdd);
export const TextIndentDecreaseLtrBundled = bundleIcon(TextIndentDecreaseLtrFilled, TextIndentDecreaseLtr);
// Create plan template icons
export { BusinessPlanIcon } from "./svgs/BusinessPlanIcon";
export { CommercialConstructionIcon } from "./svgs/CommercialConstructionIcon";
export { CompetitiveAnalysisIcon } from "./svgs/CompetitiveAnalysisIcon";
export { CrmPipelineIcon } from "./svgs/CrmPipelineIcon";
export { EmployeeOnboardingIcon } from "./svgs/EmployeeOnboardingIcon";
export { EventPlanningIcon } from "./svgs/EventPlanningIcon";
export { GoalsAndObjectivesIcon } from "./svgs/GoalsAndObjectivesIcon";
export { HelpDeskTicketsIcon } from "./svgs/HelpDeskTicketsIcon";
export { MarketingCampaignIcon } from "./svgs/MarketingCampaignIcon";
export { MarketStudyIcon } from "./svgs/MarketStudyIcon";
export { ProjectManagementIcon } from "./svgs/ProjectManagementIcon";
export { ProjectRetrospectiveIcon } from "./svgs/ProjectRetrospectiveIcon";
export { ResearchReportIcon } from "./svgs/ResearchReportIcon";
export { SimplePlanIcon } from "./svgs/SimplePlanIcon";
export { SoftwareDevelopmentIcon } from "./svgs/SoftwareDevelopmentIcon";
export { SprintPlanningIcon } from "./svgs/SprintPlanningIcon";
export { TrainingPlanIcon } from "./svgs/TrainingPlanIcon";
/**
 * Corresponds to sizes of preset SVG icons
 * Large - 28
 * Medium - 20
 * Small - 16
 */ export var IconSize = /*#__PURE__*/ function(IconSize) {
    IconSize[IconSize["Large"] = 0] = "Large";
    IconSize[IconSize["Medium"] = 1] = "Medium";
    IconSize[IconSize["Small"] = 2] = "Small";
    return IconSize;
}({});
